import { render, staticRenderFns } from "./IncidentSummary.vue?vue&type=template&id=60b4848c&"
import script from "./IncidentSummary.vue?vue&type=script&lang=ts&"
export * from "./IncidentSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports